// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  name: __t.string(),
  slug: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  createdByUserId: __t.string().name("created_by_user_id"),
  storageLimitBytes: __t.f64().name("storage_limit_bytes"),
  storageUsedBytes: __t.f64().name("storage_used_bytes"),
  plan: __t.string(),
  billingStatus: __t.string().name("billing_status"),
  stripeCustomerId: __t.string().name("stripe_customer_id"),
  stripeSubscriptionId: __t.string().name("stripe_subscription_id"),
  suspended: __t.bool(),
  seats: __t.u32(),
  billingInterval: __t.string().name("billing_interval"),
  extraStorageGb: __t.f64().name("extra_storage_gb"),
  customStorageGb: __t.f64().name("custom_storage_gb"),
  trialEndsAt: __t.option(__t.timestamp()).name("trial_ends_at"),
  currentPeriodEnd: __t.option(__t.timestamp()).name("current_period_end"),
  overLimitSince: __t.option(__t.timestamp()).name("over_limit_since"),
  billingNotices: __t.u32().name("billing_notices"),
  invoiceDays: __t.u32().name("invoice_days"),
  invoiceRequestedAt: __t.option(__t.timestamp()).name("invoice_requested_at"),
  cancelAt: __t.option(__t.timestamp()).name("cancel_at"),
});
